import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Terms() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      {/* Navbar */}
      <nav className="sticky top-0 z-50 bg-background/80 backdrop-blur-xl border-b border-border/50">
        <div className="container flex items-center justify-between py-4">
          <button
            onClick={() => navigate("/")}
            className="font-heading text-xl font-medium tracking-tight text-foreground"
          >
            oplif<span className="text-primary">.</span>
          </button>
          <Button variant="ghost" size="sm" onClick={() => navigate("/")} className="gap-2">
            <ArrowLeft className="w-4 h-4" /> Back
          </Button>
        </div>
      </nav>

      {/* Content */}
      <article className="container max-w-3xl py-16 sm:py-24">
        <header className="mb-12">
          <h1 className="font-heading text-4xl sm:text-5xl font-medium tracking-tight text-foreground mb-3">
            Terms of Service
          </h1>
          <p className="text-sm text-muted-foreground">Last updated: April 19, 2026</p>
        </header>

        <div className="space-y-10 text-[15px] leading-relaxed text-foreground/85">
          <section>
            <h2 className="font-heading text-xl font-medium text-foreground mb-3">1. Agreement</h2>
            <p>
              By accessing or using Oplif ("the Service") at oplif.com, you agree to be bound by
              these Terms of Service. If you do not agree, do not use the Service.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-medium text-foreground mb-3">2. The Service</h2>
            <p>
              Oplif is a SaaS platform providing operational and financial management tools for
              restaurant and hospitality businesses. We reserve the right to modify or discontinue
              features at any time.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-medium text-foreground mb-3">3. Account Registration</h2>
            <p>
              You must create an account to use Oplif. You are responsible for maintaining the
              confidentiality of your credentials and for all activity under your account. You
              must provide accurate information and be at least 18 years old.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-medium text-foreground mb-3">4. Subscriptions & Payments</h2>
            <p>
              Oplif offers Free, Pro ($99/mo), Studio ($179/mo), and Enterprise (custom) plans. Paid
              plans are billed monthly via Stripe. You authorize us to charge your payment method
              on a recurring basis. All fees are non-refundable except where required by law.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-medium text-foreground mb-3">5. Cancellation</h2>
            <p>
              You may cancel your subscription at any time from your account settings. Cancellation
              takes effect at the end of the current billing period. You retain access until that
              date.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-medium text-foreground mb-3">6. Acceptable Use</h2>
            <p>
              You agree not to misuse the Service, attempt to gain unauthorized access, reverse
              engineer the platform, or use it for any unlawful purpose.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-medium text-foreground mb-3">7. Intellectual Property</h2>
            <p>
              All content, features, and functionality of Oplif are owned by Oplif LLC. You may
              not copy, modify, or distribute any part of the Service without written permission.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-medium text-foreground mb-3">8. AI Features</h2>
            <p>
              Oplif uses artificial intelligence to generate insights and recommendations. These
              are for informational purposes only and do not constitute financial, legal, or
              professional advice. Oplif LLC is not liable for decisions made based on AI-generated
              content.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-medium text-foreground mb-3">9. Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by law, Oplif LLC shall not be liable for any
              indirect, incidental, or consequential damages arising from your use of the Service.
              Our total liability shall not exceed the amount you paid us in the 3 months preceding
              the claim.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-medium text-foreground mb-3">10. Termination</h2>
            <p>
              We reserve the right to suspend or terminate your account if you violate these Terms.
              You may terminate your account at any time.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-medium text-foreground mb-3">11. Governing Law</h2>
            <p>
              These Terms are governed by the laws of the State of Florida, United States, without
              regard to conflict of law principles.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-medium text-foreground mb-3">12. Changes</h2>
            <p>
              We may update these Terms at any time. Continued use of the Service after changes
              constitutes acceptance of the new Terms.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-medium text-foreground mb-3">13. Contact</h2>
            <p>
              Oplif LLC — Miami, FL, USA
              <br />
              <a href="mailto:hello@oplif.com" className="text-primary hover:underline">
                hello@oplif.com
              </a>
            </p>
          </section>
        </div>
      </article>

      {/* Footer */}
      <footer className="bg-brand-dark text-brand-dark-foreground">
        <div className="container py-8 text-xs text-white/60 text-center">
          © {new Date().getFullYear()} Oplif LLC. All rights reserved.
        </div>
      </footer>
    </div>
  );
}
